import { render, staticRenderFns } from "./OrdersPane.vue?vue&type=template&id=ebf4407c&scoped=true"
import script from "./OrdersPane.vue?vue&type=script&lang=js"
export * from "./OrdersPane.vue?vue&type=script&lang=js"
import style0 from "./OrdersPane.vue?vue&type=style&index=0&id=ebf4407c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf4407c",
  null
  
)

export default component.exports